import api from "../api";

export const getMyBadges = async () => {
  return api.getApi().get(api.getBaseUrl() + "badges/my-badges");
};

export const getAllBadges = async () => {
  return api.getApi().get(api.getBaseUrl() + "badges");
};
